/**
 * @desc 报警处理-确认
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<number>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/personal/warning/confirm',
    data,
  });
}

export function mock(data: Array<number>): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/personal/warning/confirm',
    data,
  });
}
